import { WRAP_PROPS } from '../props/wrap'
import Draggable from 'vuedraggable'
import More from './more'
import { useLayoutResizePlugin } from '../plugins/layout-resize'
import { useDraggablePlugins } from '../plugins/draggable'
import {
  getLayoutModelClassName
} from '../utils/wrap-tools'

import '../style/wrap.scss'

export default {
  props: WRAP_PROPS,
  data () {
    this._draggablePluginsInstance = useDraggablePlugins(this)
    return {
      optionList: [], // 更多里面的数据
      cellData: [], // 列表数据
      draggingMode: null, // 拖拽的模式
      cellSizeMap: {}, // 每个列的高度集合
      cellWrapHeight: this.$props.height, // 行高
      selectedKey: null, // 选中的key
    }
  },
  computed: {
    // 布局模式，单列，多列
    layoutSigne () {
      return this.$props.layoutModel === 'single'
    }
  },
  render () {
    // 拖拽的逻辑方法
    const {
      DRAGGABLE_OPTIONS,
      changeDraggingCellData,
      dragingCellDataEnd,
      changeDraggingOptionList,
      dragingOptionListEnd,
      dragingCellDataStart,
      dragingOptionListStart
    } = this._draggablePluginsInstance

    const props = this.$props
    const value = props.value
    // 是否为单行模式
    const layoutSigne = this.layoutSigne
    const resizeCellHeight = this.resizeCellHeight

    const commonProps = {
      handleChangeCheckbox: this.handleChangeCheckbox,
      handleEvent: this.handleEvent,
      resizeCellHeight,
      showCheckbox: props.showCheckbox,
      selectedKey: this.selectedKey,
      label: props.label,
      value
    }

    const [slots] = this.$slots.default || []

    const renderContent = () => {
      const optionList = this.optionList
      const number = optionList.length
      // 列表内容
      const renderCellNode = () => {
        const _cellData = this.cellData
        const useCellData = !!_cellData.length
        const cellData = useCellData ? _cellData : value

        const cellsNode = cellData.map((ele, index) => {
          return slots.cell({
            item: {
              ...ele,
              showDraggableIcon: false,
            },
            data: cellData,
            type: 'cell',
            ...commonProps
          })
        })
        const cellStyle = layoutSigne ? {
          height: this.cellWrapHeight + 'px'
        } : {}
        const cellClassName = {
          'cell': true,
          'cell-flex-start': !number
        }

        return <Draggable
          class={cellClassName}
          style={cellStyle}
          ref="cellWrap"
          value={cellData}
          options={DRAGGABLE_OPTIONS}
          key="d1"
          on-input={changeDraggingCellData}
          on-start={dragingCellDataStart}
          on-end={dragingCellDataEnd}
        >
          {
            cellsNode
          }
        </Draggable>
      }

      // 气泡内容
      const renderOptionNode = () => {
        if (layoutSigne && number) {
        const renderOption = () => {
          return optionList.map(ele => {
            return slots.option({
              item: {
                ...ele,
                showDraggableIcon: true
              },
              data: optionList,
              type: 'option',
              ...commonProps
            })
          })
        }
        const Option = renderOption()
        return <div class='more'>
          <More
            {...{
              props: {
                ...commonProps,
                data: optionList,
                number,
                morePopoverAttrs: props.morePopoverAttrs,
                customMoreOption: props.customMoreOption,
                arrowClass: this.$refs.pop && this.$refs.pop.showPopper ? 'down' : ''
              },
            }}
          >
            <Draggable
              ref='optionWrap'
              value={this.optionList}
              options={DRAGGABLE_OPTIONS}
              key="d2"
              on-input={changeDraggingOptionList}
              on-start={dragingOptionListStart}
              on-end={dragingOptionListEnd}
            >
              { Option }
            </Draggable>
          </More>
        </div>
        } else {
          return null
        }
      }
      return [renderCellNode(), renderOptionNode()]
    }
    const content = renderContent()
    const layoutClassName = getLayoutModelClassName(props.layoutModel)
    const wrapClass = [layoutClassName, props.cellWrapClassName]
    // 容器节点
    return <div class={wrapClass}>
      {
        content
      }
    </div>
  },
  methods: {
    // 更新拖拽的方式，比如从列表向气泡内拖拽或者 气泡拖到列表
    updateFlag (v) {
      this.draggingMode = v
    },
    // 更新渲染气泡的的列表数据
    updateOptionList (data) {
      this.optionList = data
      this.$parent.$emit('data-statistic-option-list-change', data)
    },
    // 获取渲染气泡的的列表数据
    getOptionList () {
      return this.optionList
    },
    // 更新外层列表的数据
    updateCellData (data) {
      this.cellData = data
      this.$parent.$emit('data-statistic-cell-data-change', data)
    },
    // 更新外层列表的数据
    getCellData () {
      return this.cellData
    },
    // 更新外层列表的数据
    getCellDataOptionList () {
      return {
        cellData: this.cellData,
        optionList: this.optionList
      }
    },
    // 收集子项的高度。用于动态的高度时
    resizeCellHeight (type, key, size) {
      if (type === 'cell') {
        this.$set(this.cellSizeMap, key, size)
      } else {
        if (this.cellSizeMap.hasOwnProperty(key)) {
          delete this.cellSizeMap[key]
        }
      }
    },
    // 创建列表和气泡内容的数据
    createRenderKeys (value) {
      if (!value || !value.length) {
        return
      }
      if (!this.layoutSigne) {
        this.updateCellData(value)
        return
      }
      const layoutDom = this.$el.querySelector('.cell')
      const {
        cellKeys,
        optionKeys
      } = useLayoutResizePlugin({
        layoutDom,
        initHeight: this.$props.height
      })
      const iter = (k) => value.find(v => v.key === k)
      const optionList = optionKeys.map(iter)
      const cellData = cellKeys.map(iter)
      this.updateOptionList(optionList)
      this.updateCellData(cellData)
    },
    /**
     * @description DOM变化之后，重新更新对应的容器内的数据
     *
     */
    resizeCellWrap () {
      const dom = this.$el.querySelector('.cell')
      this.resizeObserver = new ResizeObserver((entries) => {
        // 保证列表数据和option的顺序的情况下 重新适配数据
        const cellData = [...this.cellData, ...this.optionList]
        this.updateCellData(cellData)
        this.$nextTick(() => {
          this.createRenderKeys(cellData)
        })
      })
      this.resizeObserver.observe(dom)
    },
    // 子项高度发生变化时，取最高的size作为列表容器高度
    updateCellWrapHeight (cellSizeMap, cellData, height) {
      if (!cellData.length) {
        return height
      }
      const heightList = cellData.reduce((acc, ele) => {
        const size = cellSizeMap[String(ele.key)]
        if (size) {
          acc.push(size)
        }
        return acc
      }, [])
      const arr = heightList.length ? heightList : [height]
      const maxHeight = Math.max(...arr)
      return isFinite(maxHeight) ? maxHeight : height
    },
    // 复选框点击
    handleChangeCheckbox (val, params) {
      const { type } = params
      const data = type === 'cell' ? this.cellData : this.optionList
      const item = data.find(ele => ele.key === params.item.key)
      item && this.$set(item, 'checked', val)
      const _params = {
        isChecked: val,
        type: params.type,
        item,
        cellData: this.cellData,
        optionList: this.optionList,
      }
      this.$parent.$emit('data-statistic-select', _params)
    },
    // 事件派发
    handleEvent (event, params) {
      const { eventName, ...rest } = params
      this.$parent.$emit(eventName, {...rest, event, cellData: this.cellData, optionList: this.optionList})
      if (eventName === 'data-statistic-cell-click') {
        this.updateSelectedKey(params)
      }
    },
    /**
     *
     * @description 更新选中的数据
     * @param {*} params
     */
    updateSelectedKey (params) {
      if (!this.$props.showCheckbox && params.item) {
        this.selectedKey = params.item.key
        const _params = {
          type: params.type,
          item: params.item,
          cellData: this.cellData,
          optionList: this.optionList,
        }
        this.$parent.$emit('data-statistic-select', _params)
      }
    },
    /**
     *
     * @description 设置默认选中的key
     * @param {*} val
     */
    setDefaultSelectedKey (val) {
      for (let i = 0; i < val.length; i++) {
        const item = val[i]
        if (item.checked && item.key) {
          this.selectedKey = item.key
          break
        }
      }
    },
    /**
     *
     * @description 数据变化之后，更新渲染层的诗句
     * @param {*} val
     */
    async updateRenderWrap (val) {
      // 数据变化之后，是否启用历史拖拽的数据，如果与上次的数据的key一致情况下
      if (this.$props.draggedPriorityElevation && this._draggablePluginsInstance && this.$props.draggedId) {
        const { equal, data = [] } = await this._draggablePluginsInstance.compareCurrentDataWidthDbData(val)
        if (equal && data.length) {
          val = data
        }
      }
      // 设置checked的默认值
      if (!this.$props.showCheckbox) {
        this.setDefaultSelectedKey(val)
      }
      // 更新渲染层的数据，让DOM发生变化，重新生成 列表和 更多里面的数据
      this.updateCellData(val)
      this.$nextTick(() => {
        // 布局变化之后，更新对应的 option和cell内的数据
        this.createRenderKeys(val)
      })
    },
    /**
     * @description 销毁resizeObserver的实例
     *
     */
    unobserveResize () {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
    }
  },
  watch: {
    /**
     *
     * @description 高度变化，重新更新
     * @param {*} cellSizeMap
     */
    cellSizeMap (cellSizeMap) {
      this.cellWrapHeight = this.updateCellWrapHeight(cellSizeMap, this.cellData, this.$props.height)
    },
    value: {
      immediate: true,
      deep: true,
      /**
       *
       * @description 数据变化之后更新渲染层
       * @param {*} val
       */
      handler(val) {
        this.updateRenderWrap(val)
      }
    }
  },
  mounted () {
    // 挂载后更新渲染层的对应数据
    this.resizeCellWrap()
  },
  beforeDestroy() {
    this.unobserveResize()
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/component/wrap.js